import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, Lock } from "@phosphor-icons/react";

const SHOP_LINKS = [
  { label: "Inventory", to: "/inventory" },
  { label: "Cart", to: "/cart" },
  { label: "Secure Checkout", to: "/checkout" },
];

const SITE_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Sales", href: "/#sales" },
  { label: "Safety", href: "/#safety" },
  { label: "Contact", href: "/#contact" },
];

const LEGAL_LINKS = [
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" },
];

export default function Footer() {
  return (
    <footer
      className="relative bg-background border-t border-white/10"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-2.5 w-2.5 bg-primary block" />
              <span className="font-display font-black uppercase tracking-tighter text-lg">
                B&amp;C System
              </span>
            </div>
            <p className="text-foreground/50 max-w-md leading-relaxed">
              Industrial electrical supply and wireline field services — cables,
              transformers, switchgear and downhole logging, delivered from Pendleton, SC.
            </p>
            <div className="mt-6 space-y-3 font-mono-tech text-sm">
              <div className="flex items-start gap-3 text-foreground/70">
                <MapPin size={16} weight="light" className="text-primary mt-0.5 shrink-0" />
                <span>
                  114 Adger Rd
                  <br />
                  Pendleton, SC 29670, US
                </span>
              </div>
              <a
                href="tel:+16263863529"
                className="flex items-center gap-3 text-foreground/70 hover:text-primary transition-colors"
                data-testid="footer-phone-1"
              >
                <Phone size={16} weight="light" className="text-primary shrink-0" />
                +1 (626) 386-3529
              </a>
              <a
                href="tel:+18035791310"
                className="flex items-center gap-3 text-foreground/70 hover:text-primary transition-colors"
                data-testid="footer-phone-2"
              >
                <Phone size={16} weight="light" className="text-primary shrink-0" />
                +1 (803) 579-1310
              </a>
              <a
                href="mailto:order@bandcsystem.com"
                className="flex items-center gap-3 text-foreground/70 hover:text-primary transition-colors"
                data-testid="footer-email"
              >
                <EnvelopeSimple size={16} weight="light" className="text-primary shrink-0" />
                order@bandcsystem.com
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="mono-label text-muted-foreground mb-5">Shop</p>
            <ul className="space-y-3">
              {SHOP_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-foreground/70 hover:text-primary transition-colors"
                    data-testid={`footer-shop-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="mono-label text-muted-foreground mb-5">Company</p>
            <ul className="space-y-3">
              {SITE_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-foreground/70 hover:text-primary transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="mono-label text-muted-foreground mb-5">Legal</p>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-foreground/70 hover:text-primary transition-colors"
                    data-testid={`footer-legal-${l.label
                      .toLowerCase()
                      .replace(/\s/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 inline-flex items-center gap-2 border border-white/15 px-4 py-2">
              <Lock size={12} weight="fill" className="text-primary" />
              <span className="mono-label text-[0.6rem] text-muted-foreground">
                HTTPS · SSL Secured
              </span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="mono-label text-muted-foreground">
            © {new Date().getFullYear()} B&amp;C System · Wireline &amp; Electrical Supply
          </p>
          <p className="mono-label text-muted-foreground">
            Pendleton, SC — 24/7 Callout
          </p>
        </div>
      </div>
    </footer>
  );
}
